(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var designMode = !!(window.Shopify && Shopify.designMode);
  var hasGsap = typeof gsap !== "undefined";
  var hasScrollTrigger = hasGsap && typeof ScrollTrigger !== "undefined";

  if (hasGsap && hasScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }

  /* ---------- Countdown (vanilla, always runs) ---------- */
  function initCountdown(root) {
    var grid = root.querySelector("[data-campaign-countdown-grid]");
    var expiredEl = root.querySelector("[data-campaign-countdown-expired]");
    var endIso = (root.getAttribute("data-end") || "").replace(" ", "T");
    var end = endIso ? new Date(endIso) : null;
    var valid = end && !isNaN(end.getTime());

    var days = root.querySelector("[data-campaign-days]");
    var hours = root.querySelector("[data-campaign-hours]");
    var minutes = root.querySelector("[data-campaign-minutes]");
    var seconds = root.querySelector("[data-campaign-seconds]");

    function pad(n) {
      return n < 10 ? "0" + n : String(n);
    }

    function tick() {
      var now = Date.now();
      var diff = valid ? end.getTime() - now : 0;

      if (diff <= 0) {
        if (grid) grid.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        return;
      }

      if (grid) grid.hidden = false;
      if (expiredEl) expiredEl.hidden = true;

      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (days) days.textContent = pad(d);
      if (hours) hours.textContent = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  document.querySelectorAll("[data-campaign-countdown]").forEach(initCountdown);

  /* ---------- Spotlight + tilt cards (vanilla, always runs) ---------- */
  function initProduct(card) {
    var spot = card.querySelector(".campaign-product__spot");

    card.addEventListener("mousemove", function (event) {
      var rect = card.getBoundingClientRect();
      var x = event.clientX - rect.left;
      var y = event.clientY - rect.top;
      var px = (x / rect.width) * 100;
      var py = (y / rect.height) * 100;
      card.style.setProperty("--camp-x", px + "%");
      card.style.setProperty("--camp-y", py + "%");

      if (reduce || designMode) return;

      var rx = (0.5 - (y / rect.height)) * 6;
      var ry = ((x / rect.width) - 0.5) * 6;
      card.style.transform =
        "perspective(800px) rotateX(" + rx.toFixed(2) + "deg) rotateY(" + ry.toFixed(2) + "deg)";
    });

    card.addEventListener("mouseleave", function () {
      card.style.transform = "";
    });
  }

  document.querySelectorAll("[data-campaign-product]").forEach(initProduct);

  /* ---------- Motion effects (skip in editor / reduced motion) ---------- */
  if (designMode || reduce) return;

  if (!hasGsap) return;

  /* Marquee — infinite horizontal loop */
  document.querySelectorAll("[data-campaign-marquee]").forEach(function (marquee) {
    var track = marquee.querySelector(".campaign-marquee__track");
    if (!track) return;
    gsap.to(track, {
      xPercent: -50,
      duration: 22,
      ease: "none",
      repeat: -1,
    });
  });
})();
